import { gql } from '@grandvisionhq/graphql';

var PersonalDetailsFragment = gql`
  fragment PersonalDetailsFragment on PersonalDetails {
    firstName
    middleName
    lastName
    salutation
    phone
    dateOfBirth
    ssn
  }
`;

export { PersonalDetailsFragment as default };
//# sourceMappingURL=personal-details.js.map
